<div class="card mt-2">
    <!-- <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <span class="font-bold">{{'MI_CONSOLIDATED_REPORT_DETAILS'| translate}}</span>
        </div>
    </ng-template> -->

    <div class="">
        <div class="flex align-items-center my-2 pb-2">
            <span  [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold', 'font-size': '1.0rem', 'display': 'flex', 'justify-content': 'center', 'align-items': 'left'}" class="font-bold">{{'MI_CONSOLIDATED_REPORT_DETAILS'| translate}}</span>
        </div>
    
        <div class="p-fluid p-formgrid grid filter-blocks">
            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'FINANCIAL_YEAR'| translate}}</label>
                <p-dropdown [options]="finYearList" appendTo="body" [(ngModel)]="selectedFinYear" placeholder="{{'ALL'| translate}}"
                    optionLabel="FinancialYears" [showClear]="true"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'DISTRICT'| translate}}</label>
                <p-dropdown [options]="districtList" appendTo="body" [(ngModel)]="selectedDistrict" placeholder="{{'ALL'| translate}}"
                    optionLabel="District" [showClear]="true" (onChange)="onSelectDistrict()"></p-dropdown>
            </div>
            
            <div class="field col-6 md:col-2 filter-blocks-field" *ngIf="selectedDistrict">
                <label htmlFor="component">{{'BLOCK'| translate}}</label>
                <p-dropdown [options]="blockList" appendTo="body" [(ngModel)]="selectedBlock" placeholder="{{'ALL'| translate}}"
                optionLabel="Block" [showClear]="true" (onChange)="onSelectBlock()"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'CONSTITUENCY'| translate}}</label>
                <p-dropdown [options]="constituencyList" appendTo="body" [(ngModel)]="selectedconstituency" placeholder="{{'ALL'| translate}}"
                    optionLabel="Constituency" [showClear]="true" (onChange)="onSelectConstituency()"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field" *ngIf="selectedBlock || selectedconstituency">
                <label htmlFor="component">{{'VILLAGE'| translate}}</label>
                <p-dropdown [options]="villageList" appendTo="body" [(ngModel)]="selectedVillage" placeholder="{{'ALL'| translate}}"
                    optionLabel="Village" [showClear]="true"></p-dropdown>
            </div>
            
            <!-- <div class="field col-6 md:col-2">
                <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
                <p-autoComplete [(ngModel)]="seletedVillage"
                    placeholder="{{'VILLAGE' | translate}}" id="dd" [dropdown]="true" [multiple]="false"
                    [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)" field="Name"
                    value="Code"></p-autoComplete>
            </div> -->
    
            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'CROP_TYPE'| translate}}</label>
                <p-dropdown [options]="cropMergeList" appendTo="body" [(ngModel)]="selectedCrop" placeholder="{{'ALL'| translate}}"
                    optionLabel="label" [showClear]="true"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'CASTE'| translate}}</label>
                <p-dropdown [options]="casteList" appendTo="body" [(ngModel)]="selectedCaste" placeholder="{{'ALL'| translate}}"
                    optionLabel="Caste_Description" [showClear]="true"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'User Type'| translate}}</label>
                <p-dropdown [options]="appTypeList" appendTo="body" [(ngModel)]="selectedAppType" placeholder="{{'ALL'| translate}}"
                    optionLabel="AppType_Description" [showClear]="true"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2">
                <button pButton pRipple type="button" label="{{'Apply Filter'| translate}}" (click)="onClickApplyFilter()"
                    class="p-button-primary mt-4">
                </button>
            </div>
        </div>
    </div>

    <div class="dashboardTable">
        <!-- <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">

            </ng-template>
            <ng-template pTemplate="right">
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar> -->
        <p-table #miSurvey [value]="consolidateData" dataKey="District" [rows]="10" [paginator]="false"
            [globalFilterFields]="[
            'District',
            'totalApp',
            'TotalArea',
            'VerifiedApp',
            'verifiedAppArea',
            'PendingApp',
            'IncompleteApp',
            'incompleteAppArea',
            'rejectApp',
            'totalEstimatedApp',
            'totalEstimatedArea',
            'verifiedEstimateApp',
            'verifiedEstimateArea',
            'pendingEstimateApp',
            'verifiedEstApproved',
            'verifiedEstApprovedArea',
            'pendingEstApproved',
            'rejectedEstVerified',
            'ChallanGenerated',
            'ChallanDeposited',
            'BOQUploaded',
            'BOQMIArea',
            'BOQPending',
            'PVCompleted',
            'PV_MI_Area',
            'PV_Pending_with_JE',
            'PV_Pending_with_XEN',
            'PV_Pending_with_SDO',
            'Pending_Subsidy_Calculation',
            'ApplicationswithDMIforSubsidy_Approval',
            'Applications_Approved_at_Administartion',
            'Subsisdy_Approved_MI_Area',
            'AssistanceAmount',
            'Pending_Application_For_Payment_By_CAO',
            'Payment_Done_Application_By_CAO',
            'Payment_done_MI_Area',
            ]" [rowHover]="true"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" (onFilter)="tableDataFunction($event)" (onPage)="onPage($event)"
            [loading]="loading" [scrollable]="true" scrollHeight="{{scrollHeight}}" responsiveLayout="scroll"
            [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '300rem'}">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-end" *ngIf="consolidateData.length > 0">
                    <!-- <h5 class="m-0">{{'MI_CONSOLIDATED_REPORT'| translate}}</h5> -->

                    <!-- <div class="flex align-items-center justify-content-center"> -->

                    <!-- <div class="p-input-icon-left">
                        <div class="flex align-items-center my-2 pt-2">
                            <span  [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold', 'font-size': '1.0rem', 'display': 'flex', 'justify-content': 'center', 'align-items': 'left'}" class="font-bold">{{'MI_CONSOLIDATED_REPORT_DETAILS'| translate}}</span>
                        </div>
                    
                        <div class="p-fluid p-formgrid grid justify-content-center personal-details-form">
                            <div class="field col-6 md:col-2">
                                <label htmlFor="component">{{'DISTRICT'| translate}}</label>
                                <p-dropdown [options]="districtList" appendTo="body" [(ngModel)]="seletedDistrict" placeholder="{{'DISTRICT'| translate}}"
                                    optionLabel="Name"></p-dropdown>
                            </div>
                            
                            <div class="field col-6 md:col-2">
                                <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
                                <p-autoComplete [(ngModel)]="seletedVillage"
                                    placeholder="{{'VILLAGE' | translate}}" id="dd" [dropdown]="true" [multiple]="false"
                                    [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)" field="Name"
                                    value="Code"></p-autoComplete>
                            </div>
                    
                            <div class="field col-6 md:col-2">
                                <label htmlFor="component">{{'BLOCK'| translate}}</label>
                                <p-dropdown [options]="districtList" appendTo="body" [(ngModel)]="seletedDistrict" placeholder="{{'BLOCK'| translate}}"
                                    optionLabel="Name"></p-dropdown>
                            </div>
                    
                            <div class="field col-6 md:col-2">
                                <label htmlFor="component">{{'CONSTITUENCY'| translate}}</label>
                                <p-dropdown [options]="districtList" appendTo="body" [(ngModel)]="seletedDistrict" placeholder="{{'CONSTITUENCY'| translate}}"
                                    optionLabel="Name"></p-dropdown>
                            </div>
                    
                            <div class="field col-6 md:col-2">
                                <label htmlFor="component">{{'CROP_TYPE'| translate}}</label>
                                <p-dropdown [options]="districtList" appendTo="body" [(ngModel)]="seletedDistrict" placeholder="{{'CROP_TYPE'| translate}}"
                                    optionLabel="Name"></p-dropdown>
                            </div>
                        </div>
                    </div> -->

                    <div class="p-input-icon-right">
                        <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                            class="p-button-help"></button> -->
                        <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-download"
                            class="p-button-help"></button>

                        <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                    </div>
                    <!-- <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span> -->
                </div>
            </ng-template>
            <ng-template pTemplate="header">
            
                <tr class="header-sec-row">
                    <!-- <th pFrozenColumn pSortableColumn="District">{{'FINANCIAL_YEAR'| translate}}
                <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                <p-sortIcon field="District"></p-sortIcon>
            </th> -->
                    <th pFrozenColumn pSortableColumn="District">{{ column1Name }}
                        <!-- <p-columnFilter type="text" field="District" display="menu"></p-columnFilter> -->
                        <!-- <p-sortIcon field="District"></p-sortIcon> -->
                    </th>
                    <!-- <th pSortableColumn="Block">{{'BLOCK'| translate}}
                <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                <p-sortIcon field="Block"></p-sortIcon>
            </th>
            <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
                <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
                <p-sortIcon field="Constituency"></p-sortIcon>
            </th> -->
                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                    <th class="top-header-1" pSortableColumn="totalApp">{{'TOTAL_APP'| translate}}
                        <!-- <p-columnFilter class="filter" type="text" field="totalApp" display="menu"></p-columnFilter>
                        <p-sortIcon class="sort" field="totalApp"></p-sortIcon> -->
                    </th>
                    <th class="top-header-1" pSortableColumn="TotalArea">{{'TOTAL_AREA'| translate}}
                        <!-- <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="TotalArea"></p-sortIcon> -->
                    </th>
                    <th class="top-header-1" pSortableColumn="VerifiedApp">{{'VERIFIED_APP'| translate}}
                        <!-- <p-columnFilter type="text" field="VerifiedApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="VerifiedApp"></p-sortIcon> -->
                    </th>
                    <th class="top-header-1" pSortableColumn="verifiedAppArea">{{'VERIFIED_APP_AREA'| translate}}
                        <!-- <p-columnFilter type="text" field="verifiedAppArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="verifiedAppArea"></p-sortIcon> -->
                    </th>
                    <!-- <th class="top-header-1" pSortableColumn="PendingApp">{{'PENDING_APP'| translate}}
                        <p-columnFilter type="text" field="PendingApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="PendingApp"></p-sortIcon>
                    </th> -->
                    <th class="top-header-1" pSortableColumn="IncompleteApp">{{'INCOMPLETE+PENDING_APP'| translate}}
                        <!-- <p-columnFilter type="text" field="IncompleteApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="IncompleteApp"></p-sortIcon> -->
                    </th>
                    <th class="top-header-1" pSortableColumn="incompleteAppArea">{{'INCOMPLETE+PENDING_APP_AREA'| translate}}
                        <!-- <p-columnFilter type="text" field="incompleteAppArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="incompleteAppArea"></p-sortIcon> -->
                    </th>
                    <th class="top-header-1" pSortableColumn="rejectApp">{{'REJECTED_APP'| translate}}
                        <!-- <p-columnFilter type="text" field="rejectApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="rejectApp"></p-sortIcon> -->
                    </th>
                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                    <th class="top-header-2" pSortableColumn="totalEstimatedApp">{{'TOTAL_ESTIMATED_APP'| translate}}
                        <!-- <p-columnFilter type="text" field="totalEstimatedApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="totalEstimatedApp"></p-sortIcon> -->
                    </th>
                    <th class="top-header-2" pSortableColumn="totalEstimatedArea">{{'TOTAL_ESTIMATED_AREA'| translate}}
                        <!-- <p-columnFilter type="text" field="totalEstimatedArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="totalEstimatedArea"></p-sortIcon> -->
                    </th>
                    <th class="top-header-2" pSortableColumn="pendingEstimateApp">{{'PENDING_ESTIMATE_APP'| translate}}
                        <!-- <p-columnFilter type="text" field="pendingEstimateApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="pendingEstimateApp"></p-sortIcon> -->
                    </th>
                    <th class="top-header-2" pSortableColumn="verifiedEstimateApp">{{'VERIFIED_ESTIMATE_APP'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="verifiedEstimateApp" display="menu"></p-columnFilter>
                        <p-sortIcon field="verifiedEstimateApp"></p-sortIcon> -->
                    </th>
                    <th class="top-header-2" pSortableColumn="verifiedEstimateArea">{{'VERIFIED_ESTIMATE_AREA'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="verifiedEstimateArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="verifiedEstimateArea"></p-sortIcon> -->
                    </th>
                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->

                    <th class="top-header-3" pSortableColumn="verifiedEstApproved">{{'VERIFIED_ESTIMATE_APPROVED'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="verifiedEstApproved" display="menu"></p-columnFilter>
                        <p-sortIcon field="verifiedEstApproved"></p-sortIcon> -->
                    </th>
                    <th class="top-header-3" pSortableColumn="verifiedEstApprovedArea">
                        {{'VERIFIED_ESTIMATE_APPROVED_AREA'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="verifiedEstApprovedArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="verifiedEstApprovedArea"></p-sortIcon> -->
                    </th>
                    <th class="top-header-3" pSortableColumn="pendingEstApproved">{{'PENDING_ESTIMATE_APPROVED'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="pendingEstApproved" display="menu"></p-columnFilter>
                        <p-sortIcon field="pendingEstApproved"></p-sortIcon> -->
                    </th>
                    <th class="top-header-3" pSortableColumn="rejectedEstVerified">{{'REJECTED_ESTIMATE_VERIFIED'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="rejectedEstVerified" display="menu"></p-columnFilter>
                        <p-sortIcon field="rejectedEstVerified"></p-sortIcon> -->
                    </th>
                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                    <th class="top-header-4" pSortableColumn="ChallanGenerated">{{'CHALLAN_GENERATED'| translate}}
                        <!-- <p-columnFilter type="text" field="ChallanGenerated" display="menu"></p-columnFilter>
                        <p-sortIcon field="ChallanGenerated"></p-sortIcon> -->
                    </th>
                    <th class="top-header-4" pSortableColumn="ChallanDeposited">{{'CHALLAN_DEPOSITED'| translate}}
                        <!-- <p-columnFilter type="text" field="ChallanDeposited" display="menu"></p-columnFilter>
                        <p-sortIcon field="ChallanDeposited"></p-sortIcon> -->
                    </th>
                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                    <th class="top-header-5" pSortableColumn="BOQUploaded">{{'BOQ_UPLOADED'| translate}}
                        <!-- <p-columnFilter type="text" field="BOQUploaded" display="menu"></p-columnFilter>
                        <p-sortIcon field="BOQUploaded"></p-sortIcon> -->
                    </th>
                    <th class="top-header-5" pSortableColumn="BOQMIArea">{{'BOQ_MI_AREA'| translate}}
                        <!-- <p-columnFilter type="text" field="BOQMIArea" display="menu"></p-columnFilter>
                        <p-sortIcon field="BOQMIArea"></p-sortIcon> -->
                    </th>
                    <th class="top-header-5" pSortableColumn="BOQPending">{{'BOQ_PENDING'| translate}}
                        <!-- <p-columnFilter type="text" field="BOQPending" display="menu"></p-columnFilter>
                        <p-sortIcon field="BOQPending"></p-sortIcon> -->
                    </th>
                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                    <th class="top-header-6" pSortableColumn="PVCompleted">{{'PV_COMPLETED'| translate}}
                        <!-- <p-columnFilter type="text" field="PVCompleted" display="menu"></p-columnFilter>
                        <p-sortIcon field="PVCompleted"></p-sortIcon> -->
                    </th>
                    <th class="top-header-6" pSortableColumn="PV_MI_Area">{{'PV_MI_AREA'| translate}}
                        <!-- <p-columnFilter type="text" field="PV_MI_Area" display="menu"></p-columnFilter>
                        <p-sortIcon field="PV_MI_Area"></p-sortIcon> -->
                    </th>
                    <th class="top-header-6" pSortableColumn="PV_Pending_with_JE">{{'PV_PENDING_WITH_JE'| translate}}
                        <!-- <p-columnFilter type="text" field="PV_Pending_with_JE" display="menu"></p-columnFilter>
                        <p-sortIcon field="PV_Pending_with_JE"></p-sortIcon> -->
                    </th>
                    <th class="top-header-6" pSortableColumn="PV_Pending_with_XEN">{{'PV_PENDING_WITH_XEN'| translate}}
                        <!-- <p-columnFilter type="text" field="PV_Pending_with_XEN" display="menu"></p-columnFilter>
                        <p-sortIcon field="PV_Pending_with_XEN"></p-sortIcon> -->
                    </th>
                    <th class="top-header-6" pSortableColumn="PV_Pending_with_SDO">{{'PV_PENDING_WITH_SDO'| translate}}
                    </th>
                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                    <th class="top-header-7" pSortableColumn="ApplicationswithDMIforSubsidy_Approval">
                        {{'APP_WITH_DMI_SUBSIDY_APPROVAL'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="ApplicationswithDMIforSubsidy_Approval"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="ApplicationswithDMIforSubsidy_Approval"></p-sortIcon> -->
                    </th>
                    <th class="top-header-7" pSortableColumn="Applications_Approved_at_Administartion">
                        {{'APP_APPROVED_AT_ADMINISTRATION'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="Applications_Approved_at_Administartion"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Applications_Approved_at_Administartion"></p-sortIcon> -->
                    </th>
                    <th class="top-header-7" pSortableColumn="Pending_Subsidy_Calculation">
                        {{'PENDING_SUBSIDY_CALCULATION'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="Pending_Subsidy_Calculation" display="menu"></p-columnFilter>
                        <p-sortIcon field="Pending_Subsidy_Calculation"></p-sortIcon> -->
                    </th>
                    <th class="top-header-7" pSortableColumn="Subsisdy_Approved_MI_Area">{{'SUBSIDY_APPROVED_MI_AREA'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="Subsisdy_Approved_MI_Area" display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsisdy_Approved_MI_Area"></p-sortIcon> -->
                    </th>
                    <th class="top-header-7" pSortableColumn="AssistanceAmount">{{'ASSISTANCE_AMOUNT'| translate}}
                        <!-- <p-columnFilter type="text" field="AssistanceAmount" display="menu"></p-columnFilter>
                        <p-sortIcon field="AssistanceAmount"></p-sortIcon> -->
                    </th>
                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                    <th class="top-header-8" pSortableColumn="Pending_Application_For_Payment_By_CAO">
                        {{'PENDING_APP_FOR_PAYMENT_BY_CAO'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="Pending_Application_For_Payment_By_CAO"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Pending_Application_For_Payment_By_CAO"></p-sortIcon> -->
                    </th>
                    <th class="top-header-8" pSortableColumn="Payment_Done_Application_By_CAO">
                        {{'PAYMENT_DONE_APP_BY_CAO'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="Payment_Done_Application_By_CAO"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Payment_Done_Application_By_CAO"></p-sortIcon> -->
                    </th>
                    <th class="top-header-8" pSortableColumn="Payment_done_MI_Area">{{'PAYMENT_DONE_MI_AREA'|
                        translate}}
                        <!-- <p-columnFilter type="text" field="Payment_done_MI_Area" display="menu"></p-columnFilter>
                        <p-sortIcon field="Payment_done_MI_Area"></p-sortIcon> -->
                    </th>

                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-consolidateData>
                <tr class="body-section">
                    <!-- <td pFrozenColumn>{{ selectedYear == '' ? 'All': selectedYear }}</td> -->
                    <td pFrozenColumn>{{consolidateData.District}}</td>
                    <!-- <td>{{consolidateData.Block}}</td>
                <td>{{consolidateData.Constituency}}</td> -->
                    <!-- <td></td> -->
                    <td>{{consolidateData.totalApp}}</td>
                    <td>{{consolidateData.TotalArea}}</td>
                    <td>{{consolidateData.VerifiedApp}}</td>
                    <td>{{consolidateData.verifiedAppArea}}</td>
                    <!-- <td>{{consolidateData.PendingApp}}</td> -->
                    <!-- <td><a class="link_pointer"
                            (click)="showPendingDetailUserDialog(consolidateData, 'AppVerification')">{{
                            consolidateData.PendingApp }}</a></td> -->
                    <td>{{consolidateData.IncompleteApp}}</td>
                    <td>{{consolidateData.incompleteAppArea}}</td>
                    <td>{{consolidateData.rejectApp}}</td>
                    <!-- <td></td> -->
                    <td>{{consolidateData.totalEstimatedApp}}</td>
                    <td>{{consolidateData.totalEstimatedArea}}</td>
                    <!-- <td>{{consolidateData.pendingEstimateApp}}</td> -->
                    <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'Estimation')">{{
                            consolidateData.pendingEstimateApp }}</a></td>
                    <td>{{consolidateData.verifiedEstimateApp}}</td>
                    <td>{{consolidateData.verifiedEstimateArea}}</td>
                    <!-- <td></td> -->


                    <td>{{consolidateData.verifiedEstApproved}}</td>
                    <td>{{consolidateData.verifiedEstApprovedArea}}</td>
                    <!-- <td>{{consolidateData.pendingEstApproved}}</td> -->
                    <td><a class="link_pointer"
                            (click)="showPendingDetailUserDialog(consolidateData, 'EstVerification')">{{
                            consolidateData.pendingEstApproved }}</a></td>
                    <td>{{consolidateData.rejectedEstVerified}}</td>
                    <!-- <td></td> -->
                    <td>{{consolidateData.ChallanGenerated}}</td>
                    <td>{{consolidateData.ChallanDeposited}}</td>
                    <!-- <td></td> -->
                    <td>{{consolidateData.BOQUploaded}}</td>
                    <td>{{consolidateData.BOQMIArea}}</td>
                    <!-- <td>{{consolidateData.BOQPending}}</td> -->
                    <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'BOQ')">{{
                            consolidateData.BOQPending }}</a></td>

                    <!-- <td></td> -->
                    <td>{{consolidateData.PVCompleted}}</td>
                    <td>{{consolidateData.PV_MI_Area}}</td>
                    <!-- <td>{{consolidateData.PV_Pending_with_JE}}</td> -->
                    <td><a class="link_pointer"
                            (click)="showPendingDetailUserDialog(consolidateData, 'PVVerification', 'JE')">{{
                            consolidateData.PV_Pending_with_JE }}</a></td>
                    <!-- <td>{{consolidateData.PV_Pending_with_XEN}}</td> -->
                    <td><a class="link_pointer"
                            (click)="showPendingDetailUserDialog(consolidateData, 'PVVerification', 'XEN')">{{
                            consolidateData.PV_Pending_with_XEN }}</a></td>
                    <td><a class="link_pointer"
                            (click)="showPendingDetailUserDialog(consolidateData, 'PVVerification', 'SDO')">{{
                            consolidateData.PV_Pending_with_SDO }}</a></td>
                    <!-- <td></td> -->

                    <!-- <td>{{consolidateData.Pending_Subsidy_Calculation}}</td> -->
                    <td>{{consolidateData.ApplicationswithDMIforSubsidy_Approval}}</td>
                    <td>{{consolidateData.Applications_Approved_at_Administartion}}</td>
                    <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'Subsidy')">{{
                            consolidateData.Pending_Subsidy_Calculation }}</a></td>
                    <td>{{consolidateData.Subsisdy_Approved_MI_Area}}</td>
                    <td>{{consolidateData.AssistanceAmount}}</td>
                    <!-- <td></td> -->

                    <!-- <td>{{consolidateData.Pending_Application_For_Payment_By_CAO}}</td> -->
                    <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'stf,stv')">{{
                            consolidateData.Pending_Application_For_Payment_By_CAO }}</a></td>
                    <td>{{consolidateData.Payment_Done_Application_By_CAO}}</td>
                    <td>{{consolidateData.Payment_done_MI_Area}}</td>

                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">No Data found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <!-- <tr>
            <td class="total-col" style="font-weight: bold; color: 'rgb(168, 32, 32)'"> Total</td>
            <td class="total-col"></td>
            <td class="total-col"></td>
            <td class="total-col">{{totalApp | number:'1.0-2'}}</td>
            <td class="total-col">{{totalArea | number:'1.0-2'}}</td>
            <td class="total-col">{{verifiedApp | number:'1.0-2'}}</td>
            <td class="total-col">{{verifiedAppArea | number:'1.0-2'}}</td>
            <td class="total-col">{{pendingApp | number:'1.0-2'}}</td>
            <td class="total-col">{{incompleteApp | number:'1.0-2'}}</td>
            <td class="total-col">{{incompleteAppArea | number:'1.0-2'}}</td>
            <td class="total-col">{{rejectApp | number:'1.0-2'}}</td>
            <td class="total-col"></td>
            <td class="total-col">{{totalEstimatedApp | number:'1.0-2'}}</td>
            <td class="total-col">{{totalEstimatedArea | number:'1.0-2'}}</td>
            <td class="total-col">{{pendingEstimateApp | number:'1.0-2'}}</td>
            <td class="total-col">{{verifiedEstimateApp | number:'1.0-2'}}</td>
            <td class="total-col">{{verifiedEstimateArea | number:'1.0-2'}}</td>
            <td class="total-col"></td>
            <td class="total-col">{{verifiedEstApproved | number:'1.0-2'}}</td>
            <td class="total-col">{{verifiedEstApprovedArea | number:'1.0-2'}}</td>
            <td class="total-col">{{pendingEstApproved | number:'1.0-2'}}</td>
            <td class="total-col">{{rejectedEstVerified | number:'1.0-2'}}</td>
            <td class="total-col"></td>
            <td class="total-col">{{challanGenerated | number:'1.0-2'}}</td>
            <td class="total-col">{{challanDeposited | number:'1.0-2'}}</td>
            <td class="total-col"></td>
            <td class="total-col">{{BOQUploaded | number:'1.0-2'}}</td>
            <td class="total-col">{{BOQMIArea | number:'1.0-2'}}</td>
            <td class="total-col">{{BOQPending | number:'1.0-2'}}</td>
            <td class="total-col"></td>
            <td class="total-col">{{PVCompleted | number:'1.0-2'}}</td>
            <td class="total-col">{{PV_MI_Area | number:'1.0-2'}}</td>
            <td class="total-col">{{PV_Pending_with_JE | number:'1.0-2'}}</td>
            <td class="total-col">{{PV_Pending_with_XEN | number:'1.0-2'}}</td>
            <td class="total-col"></td>
            <td class="total-col">{{applicationswithDMIforSubsidy_Approval | number:'1.0-2'}}</td>
            <td class="total-col">{{applications_Approved_at_Administartion | number:'1.0-2'}}</td>
            <td class="total-col">{{pending_Subsidy_Calculation | number:'1.0-2'}}</td>
            <td class="total-col">{{subsisdy_Approved_MI_Area | number:'1.0-2'}}</td>
            <td class="total-col">{{assistanceAmount | number:'1.0-2'}}</td>
            <td class="total-col"></td>
            <td class="total-col">{{pending_Application_For_Payment_By_CAO | number:'1.0-2'}}</td>
            <td class="total-col">{{payment_Done_Application_By_CAO | number:'1.0-2'}}</td>
            <td class="total-col">{{payment_done_MI_Area | number:'1.0-2'}}</td>
        </tr> -->

                <tr *ngIf="consolidateData?.length > 0" class="footer-section">
                    <td pFrozenColumn class="grand-total-col"> Total </td>
                    <!-- <td pFrozenColumn class="grand-total-col"></td> -->
                    <!-- <td class="grand-total-col"></td> -->
                    <td class="grand-total-col">{{grandTotalApp | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandTotalArea | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandVerifiedApp | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandVerifiedAppArea | number:'1.0-2'}}</td>
                    <!-- <td class="grand-total-col">{{grandPendingApp | number:'1.0-2'}}</td> -->
                    <td class="grand-total-col">{{grandIncompleteApp | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandIncompleteAppArea | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandRejectApp | number:'1.0-2'}}</td>
                    <!-- <td class="grand-total-col"></td> -->
                    <td class="grand-total-col">{{grandTotalEstimatedApp | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandTotalEstimatedArea | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandPendingEstimateApp | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandVerifiedEstimateApp | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandVerifiedEstimateArea | number:'1.0-2'}}</td>
                    <!-- <td class="grand-total-col"></td> -->
                    <td class="grand-total-col">{{grandVerifiedEstApproved | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandVerifiedEstApprovedArea | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandPendingEstApproved | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandRejectedEstVerified | number:'1.0-2'}}</td>
                    <!-- <td class="grand-total-col"></td> -->
                    <td class="grand-total-col">{{grandChallanGenerated | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandChallanDeposited | number:'1.0-2'}}</td>
                    <!-- <td class="grand-total-col"></td> -->
                    <td class="grand-total-col">{{grandBOQUploaded | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandBOQMIArea | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandBOQPending | number:'1.0-2'}}</td>
                    <!-- <td class="grand-total-col"></td> -->
                    <td class="grand-total-col">{{grandPVCompleted | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandPV_MI_Area | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandPV_Pending_with_JE | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandPV_Pending_with_XEN | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandPV_Pending_with_SDO | number:'1.0-2'}}</td>
                    <!-- <td class="grand-total-col"></td> -->
                    <td class="grand-total-col">{{grandApplicationswithDMIforSubsidy_Approval | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandApplications_Approved_at_Administartion | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandPending_Subsidy_Calculation | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandSubsisdy_Approved_MI_Area | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandAssistanceAmount | number:'1.0-2'}}</td>
                    <!-- <td class="grand-total-col"></td> -->
                    <td class="grand-total-col">{{grandPending_Application_For_Payment_By_CAO | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandPayment_Done_Application_By_CAO | number:'1.0-2'}}</td>
                    <td class="grand-total-col">{{grandPayment_done_MI_Area | number:'1.0-2'}}</td>
                </tr>

            </ng-template>
            

        </p-table>
    </div>

    <!-- <div class="mt-2" style="display: flex; justify-content: center;">
        <button pButton pRipple label="Back" icon="pi pi-backward" class="p-button-primary" (click)="onClickBack()"></button>
    </div> -->

</div>

<!-- <p-dialog class="drilldown_details" [baseZIndex]="-100"
    header="Consolidated Drill Down Report"
    [(visible)]="displayPendingDetailUser" [modal]="true" [style]="{width: '100%'}" [draggable]="false" [resizable]="false">
    <app-drill-down-consolidated-report *ngIf="displayPendingDetailUser"
        [drilldownDetails]="drilldownDetails"></app-drill-down-consolidated-report>
</p-dialog> -->